var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub_top",class:_vm.bgClass},[_c('div',{staticClass:"desc"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subTitle)}}),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.subText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }